const baseRefundsApiPath = 'organizations/:organizationId/refunds';

export const refundsApiPaths = {
    refund: `${baseRefundsApiPath}/:refundId`,
} as const;
